const SECONDS_IN_HOUR = 3600;
const SECONDS_IN_MINUTE = 60;
export const splitCountdownTime = (secondsTotal) => {
    if (secondsTotal <= 0) {
        return {
            hours: 0,
            minutes: 0,
            seconds: 0,
        };
    }
    const hours = Math.floor(secondsTotal / SECONDS_IN_HOUR);
    const minutes = Math.floor((secondsTotal - hours * SECONDS_IN_HOUR) / SECONDS_IN_MINUTE);
    const seconds = secondsTotal - (minutes * SECONDS_IN_MINUTE + hours * SECONDS_IN_HOUR);
    return {
        hours,
        minutes,
        seconds,
    };
};
